import withT from "neetocommons/react-utils/withT";
import { Search as NeetoUISearchIcon, Close } from "neetoicons";
import { Button, Input } from "neetoui";
import PropTypes from "prop-types";
import { omit } from "ramda";

import { UNSUPPORTED_INPUT_PROPS } from "./constants";
import "./menubar.scss";

const Search = withT(({ t, isCollapsed = true, onCollapse, ...props }) => (
  <>
    {!isCollapsed && (
      <div className="neeto-molecules-menubar__search">
        <Input
          placeholder={t("neetoMolecules.common.actions.search")}
          prefix={<NeetoUISearchIcon />}
          type="search"
          {...omit(UNSUPPORTED_INPUT_PROPS, props)}
        />
        <Button
          data-testid="menubar-search-close-icon"
          icon={Close}
          style="text"
          onClick={onCollapse}
        />
      </div>
    )}
  </>
));

Search.propTypes = {
  /**
   * To specify whether the search field is collapsed.
   */
  isCollapsed: PropTypes.bool,
  /**
   * To provide a callback function on collapse of the search field.
   */
  onCollapse: PropTypes.func,
};

export default Search;
